import { cameraEntryActionTypes } from "./cameraEntryTypes";

/* success / error wrappers (mirrors voice slice) */
export const cameraApiResponseSuccess = (actionType: string, data: any) => ({
  type: cameraEntryActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

export const cameraApiResponseError = (actionType: string, error: string) => ({
  type: cameraEntryActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

/* simple setters */
export const setImageBlob = (blob: Blob | null) => ({
  type: cameraEntryActionTypes.SET_IMAGE_BLOB,
  payload: blob,
});

export const setImagePreviewUrl = (url: string | null) => ({
  type: cameraEntryActionTypes.SET_IMAGE_PREVIEW_URL,
  payload: url,
});

export const setProcessingStatus = (
  status: "idle" | "processing" | "done"
) => ({
  type: cameraEntryActionTypes.SET_PROCESSING_STATUS,
  payload: status,
});

/* async trigger */
export const submitImageEntry = (payload: {
  file: File;
  fileType: string; // "Booking Entry"
}) => ({
  type: cameraEntryActionTypes.SUBMIT_IMAGE_ENTRY,
  payload,
});

/* utilities */
export const clearEntryResults = () => ({
  type: cameraEntryActionTypes.CLEAR_ENTRY_RESULTS,
});

export const setErrorMessage = (msg: string) => ({
  type: cameraEntryActionTypes.SET_ERROR_MESSAGE,
  payload: msg,
});
